import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit({ ...data, role: "user" }).then(() => {
      setstate({
        loading: false,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت کاربر</title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={state.loading}
        header="ثبت کاربر"
        textbtn="لیست کاربر"
        linkbtn="/Admin/User/List"
        btnName="ثبت اطلاعات کاربر"
        submit={Handler}
      />
    </Fragment>
  );
}

export default Create;

export const input = [
  {
    label: "نام",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "fullname",
    type: "text",
  },
  {
    label: "کد ملی",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "national_code",
    type: "text",
  },
  {
    label: "شماره موبایل",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "mobile",
    type: "text",
  },
  {
    label: "رمز",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "password",
    type: "password",
  },
  {
    label: "انتخاب جنسیت ",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "gender",
    input: "select",
    options: [
      { id: "", name: "انتخاب کنید" },
      { id: "man", name: "مرد" },
      { id: "woman", name: "زن" },
    ],
  },

  {
    label: "تصویر کاربر",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "profile",
    input: "file",
    accept: "image/png, image/jpeg",
  },
];
